import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createWithEqualityFn } from 'zustand/traditional';

import { editableBotVersionSlice } from './editable-bot-version';
import { LayoutSlice, layoutSlice } from './layout-slice';

import { EditableBotVersionSlice } from '@/domain/bot';

export type TelmaPortalStore = LayoutSlice & EditableBotVersionSlice;

// Re-export for backward compatibility
export type { ImmerStateCreator } from './editable-bot-version/types';

export const useTelmaPortalStore = createWithEqualityFn<TelmaPortalStore>()(
    immer(
        devtools(
            (...a) => ({
                ...layoutSlice(...a),
                ...editableBotVersionSlice(...a),
            }),
            {
                name: 'telmaPortalStore',
            },
        ),
    ),
);
